import { render } from "./listHotspot.vue?vue&type=template&id=68274cb7"
import script from "./listHotspot.vue?vue&type=script&lang=js"
export * from "./listHotspot.vue?vue&type=script&lang=js"

import "./listHotspot.vue?vue&type=style&index=0&id=68274cb7&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__